var StateModel = Backbone.Model.extend({
  defaults: {
    currentPage: 1,
    currentView: null,
    currentSortField: "",
    currentSortDirection: "",
    currentPrice: "full",
    filters: {
      pi: []
    },
    priceLimits: []
  },

  //Hack to delete prices from filters if price values are the default ones. PHP doesn't support a different solution
  getFilters: function() {
    var filters = this.get("filters"),
      priceLimits = this.get("priceLimits"),
      filterKey = filters.pi ? "pi" : "rpi";

    if (filters[filterKey] && priceLimits.length) {
      if (filterKey === "pi") {
        _.each(filters[filterKey], function(data, key) {
          if (
            filters[filterKey][key].min === priceLimits[key].min &&
            filters[filterKey][key].max === priceLimits[key].max
          ) {
            delete filters[filterKey][key].min;
            delete filters[filterKey][key].max;
          }
        });
      } else if (
        filters[filterKey].min === priceLimits.min &&
        filters[filterKey].max === priceLimits.max
      ) {
        delete filters[filterKey].min;
        delete filters[filterKey].max;
      }
    }

    return filters;
  }
});

var FilterView = require("../../cruise/modules/_search-results.filters");

var SummaryView = require("../../cruise/modules/_search-results.summary");

var ResultsView = require("../../cruise/modules/_search-results.results");

var SearchResultsView = require("../../cruise/modules/_search-results.view");

var SearchView = require("../../cruise/modules/search");

var SearchResults = Backbone.View.extend({
  initialize: function() {
    var stateModel = new StateModel();

    new SearchResultsView({
      el: this.$el,
      FilterView: new FilterView({
        el: this.$("[data-filters]"),
        stateModel: stateModel
      }),
      ResultsView: new ResultsView({
        el: this.$("[data-results]"),
        tagsTemplate: Handlebars.compile(
          this.$("[data-promo-tag-template]").length
            ? this.$("[data-promo-tag-template]").html()
            : ""
        )
      }),
      SummaryView: new SummaryView({ el: this.$("[data-summary]") }),
      SponsoredResultsView: new ResultsView({
        el: this.$("[data-sponsored-results]")
      }),
      StateModel: stateModel
    });

    this.$el.loadModules();
  }
});

module.exports = SearchResults;
